import { EmptyState } from 'foundations-components/transitional/components/EmptyState';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import FormattedMessage from 'I18n/components/FormattedHTMLMessage';
import { ZeroQueryResultsContainer } from './ZeroQueryResultsContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const DefaultZeroQueryResults = ({
  typeDef
}) => {
  return /*#__PURE__*/_jsx(ZeroQueryResultsContainer, {
    children: /*#__PURE__*/_jsx(EmptyState, {
      paddingBlockStart: "600",
      flush: true,
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "zeroQueryResults.generic.titleText",
        options: {
          singularForm: typeDef.singularForm,
          pluralForm: typeDef.pluralForm,
          singularFormLowercase: String(typeDef.singularForm).toLowerCase(),
          pluralFormLowercase: String(typeDef.pluralForm).toLowerCase()
        }
      }),
      secondaryContent: /*#__PURE__*/_jsx(Illustration, {
        name: "empty-state-charts"
      }),
      primaryContent: /*#__PURE__*/_jsx(_Fragment, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "zeroQueryResults.generic.subText",
          options: {
            singularForm: typeDef.singularForm,
            pluralForm: typeDef.pluralForm,
            singularFormLowercase: String(typeDef.singularForm).toLowerCase(),
            pluralFormLowercase: String(typeDef.pluralForm).toLowerCase()
          }
        })
      })
    })
  });
};